﻿import $ from "jquery";
import c from "./consts";

export default class Microsoft365 {
	constructor(o, $ep) {
		this.o = o;
		this.$ep = $ep;

		this.create();
	}

	create() {
		const _ = this;

		_.$ep.on("click", c.actionContextSelector, e => _.logEvent(e.target));

		_.$ep.on("click", c.mainTabSelector, e => _.mainTabClick(e.target));

		_.$ep.on("click", c.subTabSelector, e => _.contentTabClick(e.target));

		_.$ep.on("keypress", c.mainTabSelector, e => {
			 if (e.keyCode === 32 || e.keyCode === 13) {
				 _.mainTabClick(e.target);
			 }
		});

		_.$ep.on("keypress", c.subTabSelector, e => {
			if (e.keyCode === 32 || e.keyCode === 13) {
				 _.contentTabClick(e.target);
			 }
		});
	}

	logEvent(el) {
		const _ = this,
			clientParams = {
				ActionContext: $(el).data("action-context")
			};

		ccs_cc_log.dispatchEvent(_.o.logEvent, clientParams);
	}

	mainTabClick(el) {
		const _ = this,
			$el = $(el);

		if ($el.hasClass(c.activeClass))
			return;

		$el.parent()
			.find(`.${c.activeClass}`)
			.toggleClass(c.activeClass)
			.attr('aria-selected', false);

		$el.toggleClass(c.activeClass)
			.attr('aria-selected', true)
			.closest(c.wrapperSelector)
			.find(c.tabContentSelector)
			.toggleClass(c.activeClass);
	}

	contentTabClick(el) {
		const _ = this,
			$el = $(el);

		if ($el.hasClass(c.activeClass))
			return;

		$el.parent()
			.find(`${c.subTabSelector}`)
			.attr('aria-selected', false);

		$el.attr('aria-selected', true);

		$el.closest(c.tabContentSelector)
			.find(`${c.subTabSelector}, ${c.cardsSelector}, ${c.specsSelector}`)
			.toggleClass(c.activeClass);
	}
}
